/** Calendar-based requirement deadline. Explicit document expiry always wins. */
export interface DeadlineInput {
  expiryDate?: string | null;
  dueDate?: string | null;
  applicableMonth?: string | null;
  applicableYear?: number | null;
  renewalType?: string | null;
  renewalInterval?: string | {months:number} | null;
}
const months=['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'];
const dateOnly=(s?:string|null)=>s && /^\d{4}-\d{2}-\d{2}$/.test(s) && !Number.isNaN(Date.parse(s+'T00:00:00Z')) && new Date(s+'T00:00:00Z').toISOString().slice(0,10)===s?s:null;
export function documentDeadline(input:DeadlineInput, graceMonths:number):string|null {
  const explicit=dateOnly(input.expiryDate);
  if(explicit)return explicit;
  const due=dateOnly(input.dueDate);
  if(input.renewalType==='fixed_date')return due;
  if(!input.renewalType || input.renewalType==='none')return null;
  let interval=0;
  if(input.renewalType==='monthly')interval=1;
  if(input.renewalType==='yearly')interval=12;
  if(input.renewalType==='custom_interval') {
    if(typeof input.renewalInterval==='object')interval=input.renewalInterval?.months||0;
    else {
      const value=input.renewalInterval||'';
      const years=/(\d+)\s*years?/i.exec(value);
      const mons=/(\d+)\s*mon(?:s|ths?)?/i.exec(value);
      if(!value.replace(/\d+\s*years?/ig,'').replace(/\d+\s*mon(?:s|ths?)?/ig,'').trim())interval=Number(years?.[1]||0)*12+Number(mons?.[1]||0);
    }
  }
  if(!Number.isInteger(interval)||interval<1||interval>12||12%interval!==0)return null;
  let month=months.indexOf((input.applicableMonth||'').toUpperCase())+1;
  let year=input.applicableYear;
  if(!month||!year||!Number.isInteger(year)) {
    if(!due)return null;
    year=Number(due.slice(0,4));month=Number(due.slice(5,7));
  }
  if(year<1000||year>9998||!Number.isInteger(graceMonths)||graceMonths<0||graceMonths>12)return null;
  const periodStart=Math.floor((month-1)/interval)*interval;
  return new Date(Date.UTC(year,periodStart+interval+graceMonths,0)).toISOString().slice(0,10);
}
